<template>
  <div>
    <el-row>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20">
        <div class="title">
          <h1>ShiftGrip: VR动态被动触觉装置</h1>
        </div>
        <div class="picture">
          <img src="../assets/project18_3.png.webp" />
        </div>
        <div class="paper_published">
          相关成果已申请发明专利：一种虚拟现实用手持触觉反馈装置和重量仿真模拟方法, CN118012260A
        </div>
        <div class="abstract">
          VR触觉领域需要解决的关键问题在于实现“少对多”的触觉映射，即如何降低硬件成本，用更少更简单的硬件模拟更多种类的触觉，同时保证足够的触觉真实感。
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20"><div class="picture"><img src="../assets/project18_1.png.webp" /></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20"><div class="picture"><img src="../assets/project18_2.png.webp" /></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20"><div class="picture"><img src="../assets/project18_4.png.webp" /></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20"><div class="picture"><img src="../assets/project18_5.png.webp" /></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Project18Zh",
};
</script>

<style scoped>
.picture img {
  width: 100%;
}
.paper_published {
  margin-top: 24px;
  font-size: 15px;
  color: #333;
  font-weight: 400;
  text-align: justify;
  line-height: 1.9;
  border-bottom: 1px solid #333;
  padding-bottom: 6px;
}
.abstract {
  margin-top: 26px;
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
  line-height: 1.9;
}
.grid-content {
  min-height: 36px;
}
.title {
  margin-top: 100px;
  text-align: center;
}
.title h1 {
  font-size: 30px;
  font-weight: 100;
  letter-spacing: 3px;
  color: #333333;
}
</style>
